<script setup lang="ts">
import type { PortableTextBlock, Image } from '@sanity/types';
import { computed, type Component } from 'vue';
import { THEME } from '@pkg/config/misc/theme';
import type { VideoType } from '@pkg/sanity-utils/constants/video';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    theme: string;
    anchorId?: string;
    content: Array<PortableTextBlock>;
    variant?: string;
    video?: {
      url: string;
      webm?: string;
      ogg?: string;
      fallbackImage?: Image;
      controls?: boolean;
      autoplay?: boolean;
      videoType?: VideoType;
    };
    image?: Image;
    mediaType?: string;
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  theme: props.block?.theme || THEME.DARK,
  content: props.block?.content,
  variant: props.block?.variant,
  image: props.block?.image,
  video: props.block?.video,
  mediaType: props.block?.mediaType,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data"/>
</template>
